import { render, staticRenderFns } from "./subscriptionplan.vue?vue&type=template&id=694f2d68&scoped=true"
import script from "./subscriptionplan.vue?vue&type=script&lang=js"
export * from "./subscriptionplan.vue?vue&type=script&lang=js"
import style0 from "./subscriptionplan.vue?vue&type=style&index=0&id=694f2d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f2d68",
  null
  
)

export default component.exports